import axios from "axios";
import { apis } from "../../constants/apis";
import httpService from "../httpService";
import { vmrsGet } from "../vmrsApi";

class BaseMapService
{
  GetbaseMap()
  {
    return vmrsGet(apis.basemap.url);
  }
  PostBasemap(body: any)
  {
    return httpService.post(apis.basemap.url, body);
  }
}

export default new BaseMapService();
